// src/components/forms/mapping-editor/TextFieldDefaultsEditor.tsx (Create this file)
import React, { useCallback } from 'react';
import { SimpleListEditor } from './SimpleListEditor'; // Import generic editor
import { TextFieldDefault } from '../../../../interfaces/dynamicForms/PdfMapping';
import FormInput from '../formBuilder/FormInput';

interface TextFieldDefaultsEditorProps {
  defaults: TextFieldDefault[] | undefined;
  updateDefaults: (newDefaults: TextFieldDefault[]) => void;
}

const TextFieldDefaultsEditor: React.FC<TextFieldDefaultsEditorProps> = ({ defaults, updateDefaults }) => {

  // Function to render the inputs for a single TextFieldDefault item
  const renderTextFieldDefaultItem = useCallback((
    item: TextFieldDefault,
    index: number,
    onChange: (index: number, updatedItem: TextFieldDefault) => void
  ) => {
    // Handler specific to changes within one item's inputs
    const handleItemInputChange = (field: keyof TextFieldDefault, value: string) => {
      onChange(index, { ...item, [field]: value });
    };

    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <FormInput
          label="Form Field ID"
          id={`tfDefault-field-${index}`}
          value={item.Field || ''}
          onChange={(e) => handleItemInputChange('Field', e.target.value)}
          placeholder="e.g., myFormField"
          required
        />
        <FormInput
          label="PDF Field Name"
          id={`tfDefault-pdfField-${index}`}
          value={item.PdfField || ''}
          onChange={(e) => handleItemInputChange('PdfField', e.target.value)}
          placeholder="e.g., TextField10"
          required
        />
        <FormInput
          label="Default Value"
          id={`tfDefault-default-${index}`}
          value={item.Default || ''}
          onChange={(e) => handleItemInputChange('Default', e.target.value)}
          placeholder="e.g., N/A"
          required
        />
      </div>
    );
  }, []); // No external dependencies needed for render function itself

  // Function to create a new, empty TextFieldDefault item
  const createDefaultTextFieldDefaultItem = useCallback((): TextFieldDefault => {
    return { Field: '', PdfField: '', Default: '' };
  }, []);

  return (
    <SimpleListEditor
      items={defaults} // Pass the defaults array
      updateItems={updateDefaults} // Pass the callback to update the parent's state
      renderItem={renderTextFieldDefaultItem} // Pass the function to render each item
      createDefaultItem={createDefaultTextFieldDefaultItem} // Pass the function to create new items
      title="Text Field Defaults"
      itemTitle="Default Rule" // Customize item name
      addButtonText="Add Default Rule" // Customize button text
    />
  );
};

export default TextFieldDefaultsEditor;